export const DATASETS_ROUTES = {
  LIST: '/datasets',
  DETAIL: '/datasets/$id',
} as const;
